import React, { useState } from 'react';
import { Button, Col, Dropdown, Modal, Tab } from 'react-bootstrap';
import Loader from '../Shared/Loader';

import Table, { RowType } from '../Shared/CustomTable';
import CustomerPlayerTable from './CustomerPlayerTable';
import { ShortTeamsData } from './types';
import DatePicker from 'components/Shared/DatePicker/DatePicker';


class MyVerticallyCenteredModal extends React.Component<{ show: boolean, onHide: () => void}> {
  render() {
    return (
      <Modal
        className="modal-content-04"
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Team Zones
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Team Walk Yards </p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Jog Yards</p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Run Yards </p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Sprint Yards</p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Max Sprint Yards </p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Max Sprint Yards </p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <div className="btn-t-edit">
            <button className="btn-transparet">Cancel</button>
            <button className="btn-green">Save</button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

class SecondModal extends React.Component<{ show: boolean, onHide: () => void}> {
  render() {
    return (
      <Modal
        className="modal-content-05"
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="material-textbox" id="first-name-input">
            <input className="material-input" required />
            <span className="material-label">Enter Full Name</span>
          </div>
          <div className="material-textbox" id="first-name-input">
            <input className="material-input" required />
            <span className="material-label">Enter Team Role</span>
          </div>
          <div className="material-textbox" id="first-name-input">
            <input className="material-input" required />
            <span className="material-label">Enter Email Address</span>
          </div>
          <p>Choose Application Role</p>
          <Dropdown className="btn-90">
            <Dropdown.Toggle id="dropdown-basic" className="btn-gray-l">
              Select
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1">1000</Dropdown.Item>
              <Dropdown.Item href="#/action-2">1000</Dropdown.Item>
              <Dropdown.Item href="#/action-3">1000</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className="add-user-b">
            <button className="btn-transparet">Cancel</button>
            <button className="btn-blue">Save</button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ({ teamsData } : { teamsData: Array<ShortTeamsData> }) => {
  const [modalShow, setModalShow] = useState(false);
  const [showSecondModal, setSecondModal] = useState(false);
  const modalClose = () => setModalShow(false);
  const secondClose = () => setSecondModal(false);
  const day = new Date();
  const [date, setDate]= useState(day);
  // max-width = 1006
  const headers = [
    { content: 'NAME', style: { width: '174px' }, class: 'l-ll t-ll' },
    { content: 'EMAIL ADDRESS', style: { width: '215px' }, class: 't-ll' },
    { content: 'TEAM ROLE', style: { width: '176px' }, class: 't-ll' },
    { content: 'APLICATION ROLE', style: { width: '225px' } },
    { style: { width: '216px' }, class: 't-ll' }
  ];
  const rows: RowType[] = [];
  rows.push({
    columns: [
      { class: 'l-ll t-ll', content: 'Jim Brown' },
      { class: 't-ll', content: 'jbrown@steelers.com' },
      { class: 't-ll', content: 'General Manager' },
      { content: 'Team Admin' },
      {
        style: { position: 'relative', textAlign: 'right' },
        class: 't-ll',
        content: <Button className="btn-blue">Edit</Button>
      }
    ],
    id: 'customers-table-1'
  }, {
    columns: [
      { class: 'l-ll t-ll', content: 'Jim Brown' },
      { class: 't-ll', content: 'jbrown@steelers.com' },
      { class: 't-ll', content: 'General Manager' },
      { content: 'Team Admin' },
      {
        style: { position: 'relative', textAlign: 'right' },
        class: 't-ll',
        content: <Button className="btn-blue">Edit</Button>
      }
    ],
    id: 'customers-table-2'
  }, {
    columns: [
      { class: 'l-ll t-ll', content: 'Jim Brown' },
      { class: 't-ll', content: 'jbrown@steelers.com' },
      { class: 't-ll', content: 'General Manager' },
      { content: 'Team Admin' },
      {
        style: { position: 'relative', textAlign: 'right' },
        class: 't-ll',
        content: <Button className="btn-blue">Edit</Button>
      }
    ],
    id: 'customers-table-3'
  }, {
    columns: [
      { class: 'l-ll t-ll', content: 'Jim Brown' },
      { class: 't-ll', content: 'jbrown@steelers.com' },
      { class: 't-ll', content: 'General Manager' },
      { content: 'Team Admin' },
      {
        style: { position: 'relative', textAlign: 'right' },
        class: 't-ll',
        content: <Button className="btn-blue">Edit</Button>
      }
    ],
    id: 'customers-table-4'
  });

  const loaderProps = {
    style: { height: 'calc(100% - 60px)', backgroundColor: 'white', opacity: '1', zIndex: 901 }
  };

  return (
    <Col sm={9}>
      <Tab.Content>
        {teamsData.map((team: ShortTeamsData) => {
          return (<Tab.Pane eventKey={team.teamId} key={'tab-pane' + team.teamId}>
            <div className="customer-b-01">
              <div className="b-customer" style={{ paddingBottom: '0' }}>
                <div className="title-c">
                  <div className="team-tt">
                    <img src={`/assets/images/logos/${team.teamAbbrName}.png`} alt="" height="30px" />
                    {`${team.teamAbbrName} ${team.teamNick}`}
                  </div>
                  <div className="bb-c">
                    <MyVerticallyCenteredModal show={modalShow} onHide={modalClose} />
                    <button
                      className="btn-gray"
                      onClick={() => {
                        setModalShow(true);
                      }} style={{ width: '116px' }}
                    >Edit Team Zones
                    </button>
                    <button className="btn-gray" style={{ width: '128px' }}>Edit Relative Zones</button>
                    <button className="btn-gray" style={{ width: '206px' }}>Edit Max Speed Target by Position</button>
                    <button className="btn-gray" style={{ width: '163px' }}>Edit Position Group Zones</button>
                  </div>
                </div>
              </div>
              <div className="customer-title-players">
                <Loader {...loaderProps} />
                <div style={{display:'flex', justifyContent:'flex-end'}}>
                <div className="title-b" style={{display: 'flex', alignItems: 'center'}}>
                  <span style={{marginTop: '3px'}}> Players Custom Zones For</span>
                  <div className="timep-custom" style={{marginLeft: '5px'}}>
                  <DatePicker date={date} setDate={setDate} isCustomZone={true}/>
              </div>
                </div>
                </div>
                <div>
                  <div style={{ width: '1008px' }}>
                   <CustomerPlayerTable teamId={team.teamId.toString()} league={team.league} selectedDate={date} />
                  </div>
                </div>
              </div>
            </div>
          </Tab.Pane>);
        })}
      </Tab.Content>
    </Col>
  );
};
